import { Heading, IconButton, Text, HStack } from '@genial/components';
import React from 'react';

export namespace HeaderTypes {
  export interface Props {
    onGoBack?: () => void;
    isMobile: boolean;
  }
}

export const Header: React.FC<HeaderTypes.Props> = ({ onGoBack, isMobile }) => {
  return (
    <HStack alignItems="center" space="stack.nano">
      <IconButton
        icon="ArrowLeft"
        testId="return-button"
        shadow={isMobile ? undefined : 3}
        variant={isMobile ? 'unstyled' : 'link'}
        iconColor={isMobile ? 'neutral.dark' : 'brand.tertiary.principal'}
        iconSize="xs"
        padding={{ base: 0, sm: 'inset.nano' }}
        onPress={onGoBack}
      />
      {isMobile ? (
        <Text fontSize="fontsize.lg" variant="bold">
          Histórico de proventos
        </Text>
      ) : (
        <Heading testId="customer-details-heading">Histórico de proventos</Heading>
      )}
    </HStack>
  );
};
